import React from "react";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";

class Undercover extends React.Component {
  /*Scroll to top of page at init*/
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>
            RPGONE Translations - Undercover Cops - English Translation v1.0
            SNES アンダーカバーコップス
          </title>
          <meta
            name="title"
            content="RPGONE Translations - Undercover Cops - English Translation v1.0 SNES アンダーカバーコップス"
          />
          <meta
            name="description"
            content="English Translation v1.0 - It's 2043 and Dr. Crayborn and his gang have taken control of New York's streets. Commissioner Gordon has made one last plea for help and called three of the finest City Sweepers - Undercover Cops for the SNES / Super Famicom / Super Nintendo by RPGONE Translations"
          />
        </Helmet>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <span className="title-centered" />
              <div className="center-image">
                <img
                  src={require("./img/proj/undercover_00000.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/undercover_00001.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/undercover_00002.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/undercover_00003.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/undercover_00007.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/undercover_00005.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/undercover_00004.png")}
                  alt=""
                  className="imageResize"
                />
                <img
                  src={require("./img/proj/undercover_00006.png")}
                  alt=""
                  className="imageResize"
                />
                <br />
                <br />
                <i>
                  <div>
                    Undercover Cops - City Sweepers<br />Original release: 3rd
                    March 1995 on Super Famicom (Snes / Super Nintendo)
                  </div>
                </i>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Story</div>
              </b>
              <br />
              It's 2043 and Dr. Crayborn and his gang have taken control of New
              York's streets. The city mayor has made one last plea for help and
              called three of the finest City Sweepers: Zan, an ex-karate
              master; Matt, an ex-professional football player and Rosa, the
              only female vigilante whose boyfriend was killed by villains. They
              must fight the gang and eliminate Dr. Crayborn in order to restore
              peace to the city.
              <br />
              <br />
              <div className="center-image">
                <a href={require("./img/box/Undercover Cops - Box Cover.jpg")}>
                  <img
                    src={require("./img/box/Undercover Cops - Box Cover.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>{" "}
                <a href={require("./img/box/Undercover Cops - Box Back.jpg")}>
                  <img
                    src={require("./img/box/Undercover Cops - Box Back.jpg")}
                    alt=""
                    className="imageResize imageSizing350"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>Downloads</div>
              </b>
              <br />
              <a
                href={require("./files/Undercover Cops - English v1.0.zip")}
                download="Undercover Cops - English v1.0.zip"
              >
                English Translation patch v1.0
              </a>{" "}
              by RPGONE
              <br />
              <br />
              <a href="https://traduccionessemco.blogspot.com/2019/02/traduccion-de-undercover-cops-de-snes.html">
                Spanish Translation patch v1.1
              </a>{" "}
              by Semco
              <br />
              <br />
              <a href="https://www.romhacking.net/translations/4225/">
                Project page on romhacking.net
              </a>
              <br />
            </div>
          </div>
        </div>

        <div className="col-centered">
          <div className="panel panel-primary">
            <div className="panel-body">
              <b className="subtitle">
                <div>PAR Codes</div>
              </b>
              <br />
              <b>C08D8CAD</b> - No damage from enemies<br />
              <br />
              <b>C0E5B80A</b> - Show stage select at options menu<br />
              <br />
              <b>Good Ending Hint</b>
              <br />
              <img
                src={require("./img/proj/undercover_00010.png")}
                alt=""
                className="imageResize"
              />
              <br />To get the good ending, attack Dr. Crayborn when he is
              dropping the bomb.
              <br />
              <br />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Undercover);



// WEBPACK FOOTER //
// ./src/Undercover.js